import * as React from 'react'
import { NonThrowingComponent } from './NonThrowingComponent'

type Props = {
    placeholder: React.ReactElement<unknown>
    render: () => React.ReactElement<unknown>
}

type State = {
    visible: boolean
}

export class Lazy extends NonThrowingComponent<Props, State> {
    public element: HTMLElement
    private observer: IntersectionObserver

    constructor(props: Props) {
        super(props)
        this.state = {
            visible: false,
        }
    }

    public componentWillUnmount() {
        if (this.observer) {
            this.observer.unobserve(this.element)
        }
    }

    public componentDidMount() {
        this.observer = new IntersectionObserver(
            (entries: IntersectionObserverEntry[]) => {
                const entry = entries[0]
                if (entry && entry.isIntersecting) {
                    this.setState({ visible: true })

                    if (this.element != null) {
                        this.observer.unobserve(this.element)
                    }
                }
            },
            { rootMargin: '1000px' }
        )
        this.observer.observe(this.element)
    }

    public tryRender() {
        return (
            <div className="AppCore__ui__Lazy" ref={(ref) => (this.element = ref)}>
                {this.state.visible ? this.props.render() : this.props.placeholder}
            </div>
        )
    }
}
